import React from "react";

import classes from "./SideDrawer.module.css";
import SearchOptions from "../../SearchP/SearchOptions/SearchOptions";

const SideDrawer = (props)=>{
    let sideClasses = `${classes.SideDrawer} ${classes.Closed}`
    if (props.show){
        sideClasses = `${classes.SideDrawer} ${classes.Open}`
    }
    return (
        <div className={sideClasses}>
          {props.show?  <SearchOptions reLoadCompnent={props.reLoadCompnent}/>: null}
        </div>
    );
};

export default SideDrawer;